export default __webpack_public_path__ + "static/media/training-image-03.b518bec8.jpg";